import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'

/**
 * NovelMello 榜单页皮肤 token
 *
 * 说明：这些值来自 NovelMello 设计 tokens（粉 #F0509B + 紫 #7C4DE8/#9B5CF0），
 * 属于页面私有、未进入 UnoCSS 的 n-* 变量体系，因此放在页面配置层。
 * 组件通过直接 import 使用（与 history/configs/novelmello.ts 的做法一致），
 * 不占用 RankingPageConfig 契约字段。
 */
export const novelmelloRankingTheme = {
  // ---- 页面 ----
  pageBg: '#FBF6FB',
  // 顶部浅粉紫氛围渐变（绝对定位铺底，不挡内容）
  halo: 'linear-gradient(180deg, #FDE8F1 0%, #EDE4FD 60%, #FBF6FB 100%)',
  // ---- 文本 ----
  ink1: '#2B1B34',
  ink2: '#71607E',
  ink3: '#AB9BB8',
  // ---- 白色大卡 ----
  cardBg: '#FFFFFF',
  cardShadow: '0 4px 16px rgba(124, 77, 232, 0.08)',
  // ---- 名次徽章（CSS 数字徽章，不用图片）----
  rank1Bg: 'linear-gradient(135deg, #F0509B 0%, #9B5CF0 100%)',
  rank2Bg: '#9B5CF0',
  rank3Bg: '#F0509B',
  rankRestBg: '#FDEFF6',
  rankTopText: '#FFFFFF',
  rankRestText: '#AB9BB8',
  // ---- chips（粉紫交替）----
  chipPinkBg: '#FDEFF6',
  chipPinkText: '#F0509B',
  chipPurpleBg: '#F1EAFD',
  chipPurpleText: '#7C4DE8',
  /** chips 最多展示几个（只取 tagList） */
  chipLimit: 3,
} as const

/**
 * NovelMello 品牌榜单页配置
 *
 * - theme.rankGradient：NovelMello 标题用实色 ink-1，不做渐变文字，
 *   但 useRanking 会读取该字段，故给 'none' 占位。
 * - resources：不使用麦穗 / 奖牌图片（徽章由 CSS 数字实现），全部留空串。
 */
export const rankingConfig: RankingPageConfig = {
  theme: {
    rankGradient: 'none',
  },
  resources: {
    homeBg: '',
    spikeletL: '',
    spikeletR: '',
    goldMedal: '',
    silverMedal: '',
    bronze: '',
    medal: '',
  },
  texts: rankingCommonConfig.texts,
}
